import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { G_API_GET_BANNERS } from "../../../constants/api";
import useFetch from "../../../hooks/useFetch";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import * as routes from "../../../constants/routes";

const parseList = (value) => {
  try {
    return JSON.parse(value || "[]");
  } catch {
    return [];
  }
};

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
};

const CardContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: "6px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "relative",
  overflow: "hidden",
  height: "100%",
  minHeight: "180px",
  "& .slick-dots": {
    position: "relative",
    bottom: "8px",
    marginTop: 0,
  },
  "& .slick-dots li button:before": {
    fontSize: "4px",
    color: "white",
    opacity: 0.3,
  },
  "& .slick-dots li.slick-active button:before": {
    opacity: 1,
    color: "white",
  },
}));

const NewReleaseCard = ({ currentUser }) => {
  const navigate = useNavigate();
  const [response] = useFetch({ url: G_API_GET_BANNERS("panel") });
  const profile = currentUser?.profile;
  const userPlanName = currentUser?.typePlan;
  const hasTrainingPermission = currentUser?.tags?.length > 0;

  const bannersWithImage = (response || [])
    .map((banner) => ({ ...banner, image: Object.values(banner.urls || {})[0] }))
    .filter((banner) => banner.image);

  const { matched, standard } = bannersWithImage.reduce(
    (acc, banner) => {
      const allowedProfiles = parseList(banner.profile_can_view);
      const allowedPlans = parseList(banner.plan_name_can_view);
      if (!allowedProfiles.some((p) => p.toLowerCase() === profile?.toLowerCase())) return acc;

      if (allowedPlans.some((p) => p.toLowerCase() === userPlanName?.toLowerCase())) acc.matched.push(banner);
      if (allowedPlans.some((p) => p.toLowerCase() === "standard")) acc.standard.push(banner);
      return acc;
    },
    { matched: [], standard: [] }
  );

  const displayedBanners = matched.length > 0 ? matched : standard;

  const handleClickBanner = (banner) => {
    const destination = banner?.link_destination;

    if (!destination) return;

    if (destination.startsWith("http")) {
      window.open(destination, "_blank");
      return;
    }

    if (destination === "/fazer-teste?banner=quiz" && hasTrainingPermission) {
      navigate(routes.R_TAKE_TEST_PLAN);
      return;
    }
    navigate(destination);
  };

  return (
    <CardContainer>
      {displayedBanners.length > 1 ? (
        <Slider {...sliderSettings}>
          {displayedBanners.map((banner) => (
            <Box
              key={banner.banner_id}
              component="img"
              src={banner.image}
              alt={banner.banner_name}
              onClick={() => handleClickBanner(banner)}
              role="button"
              data-promo-id={banner.category}
              data-promo-name={banner.banner_name}
              data-promo-slot={banner.displayed_screen}
              data-creative-name={banner.link_destination}
              sx={{
                width: "100%",
                height: "100%",
                display: "block",
                objectFit: "contain",
                cursor: "pointer"
              }}
            />
          ))}
        </Slider>
      ) : (
        displayedBanners[0] && (
          <Box
            component="img"
            src={displayedBanners[0].image}
            alt={displayedBanners[0].banner_name}
            onClick={() => handleClickBanner(displayedBanners[0])}
            role="button"
            data-promo-id={displayedBanners[0].category}
            data-promo-name={displayedBanners[0].banner_name}
            data-promo-slot={displayedBanners[0].displayed_screen}
            data-creative-name={displayedBanners[0].link_destination}
            sx={{
              width: "100%",
              height: "100%",
              display: "block",
              objectFit: "contain",
              cursor: "pointer"
            }}
          />
        )
      )}
    </CardContainer>
  );
};

export default NewReleaseCard;
